import { useMemo } from 'react'

import { ForeignPhotoValue } from 'components/page/ForeignProfile/ForeignProfile.constants'
import { useIncognitoBaseUrl } from 'components/page/ForeignProfile/hooks/useIncognitoBaseUrl'
import { useAuthorized } from 'hooks/useAuthorized'

export const useForeignPhotoContext = (
  hasIncognito: boolean
): ForeignPhotoValue => {
  const authorized = useAuthorized()
  const baseHrefPhoto = useIncognitoBaseUrl(hasIncognito)

  return useMemo(
    () => ({
      baseHrefPhoto,
      useAuthorizationUrl: hasIncognito && !authorized,
    }),
    [baseHrefPhoto, hasIncognito, authorized]
  )
}
